import * as React from 'react';
import SearchResults from '../presentational/SearchResults/SearchResults';
import Search from '../presentational/Search/Search';
import ErrorBoundary from '../presentational/Error/ErrorBoundary';

const SearchResultsPage = () => (
	<React.Fragment>
		<Search isAdvanced={true} />
		<ErrorBoundary>
			<SearchResults />
		</ErrorBoundary>
	</React.Fragment>
);

export default SearchResultsPage;
